<template>
  <h6 class="element-header">
    Betreutes Wohnen
  </h6>

  <div>
    <h5 class="form-header">Berichtsportale:</h5>

    <div class="row">
      <div class="col-lg-6 col-md-12 col-sm-12 text-left">
        <p style="margin-bottom: 5px;">
          FACHKRAFTE - {{ coaching.specialistFullName }}
        </p>
        <p>
          Einheiten erledigt: {{ formatNumber(unitsDoneBySpecialist) }} &nbsp; - &nbsp;
          Es verbleiben noch {{ formatNumber(unitsLeftToBeDone) }}
          Einheiten, um 70 % zu erreichen
        </p>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12  text-md-right">
        <p style="margin-bottom: 5px;">
          ASSISTENZKRÄFTE - {{ coaching.supervisorFullName }}
        </p>
        <p>
          Einheiten erledigt:
          {{ formatNumber(coaching?.unitsDoneBySupervisor || 0) }}
        </p>
      </div>
    </div>

    <div class="progress mb-4">
      <div
          class="progress-bar"
          role="progressbar"
          :aria-valuemax="100"
          :aria-valuemin="0"
          :aria-valuenow="coaching?.specialistPercentUnitsDone"
          :style="progressBarStyle(coaching?.specialistPercentUnitsDone)">
        <span v-if="coaching?.specialistPercentUnitsDone > 0">
          {{ coaching?.specialistPercentUnitsDone }}%
        </span>
      </div>
      <span style="color: white; height: 100%; border-radius: 3px">|</span>
      <div
          class="progress-bar"
          role="progressbar"
          :aria-valuemax="100"
          :aria-valuemin="0"
          :aria-valuenow="coaching?.supervisorPercentUnitsDone"
          :style="progressBarStyle(coaching?.supervisorPercentUnitsDone)">
         <span v-if="coaching?.supervisorPercentUnitsDone > 0">
          {{ coaching?.supervisorPercentUnitsDone }}%
        </span>
      </div>
    </div>

    <div class="row m-0 portal_user_data p-3" style="font-size: 15px">
      <div class="col-lg-6 col-md-12">
        <div class="row">
          <div class="col-sm-5 col-6 mb-1"><strong>Vorname:</strong></div>
          <div class="col-sm-7 col-6 mb-1 font-italic">{{ coaching?.unemployed?.firstName }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Nachname:</strong></div>
          <div class="col-sm-7 col-6 mb-1 font-italic">{{ coaching?.unemployed?.lastName }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>JC / AA Nummer:</strong></div>
          <div class="col-sm-7 col-6 mb-1 font-italic">{{ coaching?.unemployed?.aaNumber || 'Keine Angaben' }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Versicherungsnr:</strong></div>
          <div class="col-sm-7 col-6 mb-1 font-italic">{{ coaching?.unemployed?.insuranceNumber || 'Keine Angaben' }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Email:</strong></div>
          <div class="col-sm-7 col-6 mb-1 font-italic text-break">{{ coaching?.unemployed?.email || 'Keine Angaben' }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Telefonnummer:</strong></div>
          <div class="col-sm-7 col-6 mb-1 font-italic">{{ coaching?.unemployed?.phone || 'Keine Angaben' }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Sachbearbeiter:</strong></div>
          <div class="col-sm-7 col-6 mb-1 font-italic">{{ coaching?.coaching?.clerk || 'Keine Angaben' }}</div>

          <div class="col-sm-5 col-6 mb-1"><strong>Adresse:</strong></div>
          <div class="col-sm-7 col-6 mb-1 font-italic">
            {{ coaching?.unemployed?.address }},
            {{ coaching?.unemployed?.zip }} {{ coaching?.unemployed?.city }}
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
        <div class="d-flex flex-wrap justify-content-lg-end justify-content-center">

          <div class="portal-export-item m-0 text-center" style="min-width: 110px;">
            <a href="javascript:void(0)"
               class="btn portal_pdf_export w-100 d-flex flex-column align-items-center p-2"
               @click="downloadFile(`/portal/assisted-living-coaching/final-report-short-version-pdf/${coaching.id}`)">
              <img src="../../../../assets/img/pdf_icon_version4.png"
                   alt="PDF"
                   style="width: 55px; height: auto; object-fit: contain;"
                   class="mb-2"/>
              <p class="small mb-0 text-dark font-weight-bold" style="line-height: 1.1;">
                Abschlussbericht <br> (Kurz)
              </p>
            </a>
          </div>

          <div class="portal-export-item text-center" style="min-width: 110px;">
            <a href="javascript:void(0)"
               class="btn portal_pdf_export w-100 d-flex flex-column align-items-center p-2"
               @click="downloadFile(`/portal/assisted-living-coaching/final-report-long-version-pdf/${coaching.id}`)">
              <img src="../../../../assets/img/pdf_icon_version4.png"
                   alt="PDF"
                   style="width: 55px; height: auto; object-fit: contain;"
                   class="mb-2"/>
              <p class="small mb-0 text-dark font-weight-bold" style="line-height: 1.1;">
                Abschlussbericht <br> (Lang)
              </p>
            </a>
          </div>

          <div class="portal-export-item text-center" style="min-width: 110px;" v-if="coaching.digitalSignature">
            <a href="javascript:void(0)"
               class="btn portal_pdf_export w-100 d-flex flex-column align-items-center p-2"
               @click="downloadFile(`/portal/assisted-living-coaching/meeting-list-pdf/${coaching.id}`, undefined, filtersFormated)">
              <img src="../../../../assets/img/pdf_icon_version4.png"
                   alt="PDF"
                   style="width: 55px; height: auto; object-fit: contain;"
                   class="mb-2"/>
              <p class="small mb-0 text-dark font-weight-bold" style="line-height: 1.1;">
                Anwesenheit <br> (PDF)
              </p>
            </a>
          </div>

          <div
              v-if="coaching.digitalSignature"
              class="portal-export-item  text-center"
              style="min-width: 110px;">
            <a href="javascript:void(0)"
               class="btn portal_pdf_export w-100 d-flex flex-column align-items-center p-2"
               @click="downloadFile(`/portal/assisted-living-coaching/meeting-list-excel/${coaching.id}`, undefined, filtersFormated, false)">
              <img src="../../../../assets/img/excel_icon.jpg"
                   alt="Excel"
                   style="width: 55px; height: auto; object-fit: contain;"
                   class="mb-2"/>
              <p class="small mb-0 text-dark font-weight-bold" style="line-height: 1.1;">
                Anwesenheit <br> (Excel)
              </p>
            </a>
          </div>

        </div>
      </div>

      <div class="col-12 mt-4 border-top pt-3">
        <div class="d-flex flex-column align-items-end">
          <div class="h5 mb-0">
            <strong>{{ calculatedUnits?.unitsDone }}</strong> / {{ calculatedUnits?.maxUnits }} Einheiten
          </div>
          <div v-if="calculatedUnits?.unitsLeft < 3" class="text-danger font-weight-bold middle mt-1">
            Sie haben noch {{ calculatedUnits.unitsLeft.toFixed(2) }} offene Einheiten
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { downloadFile } from '@/shared/functions';
import { computed, defineProps, toRefs } from 'vue';

const props = defineProps({
  coaching: {
    type: Object,
    required: true,
  },
  calculatedUnits: {
    type: Array,
    required: true,
  },
  filtersFormated: {
    type: Object,
    required: false,
  },
});

const coaching = toRefs(props)[ 'coaching' ];

const specialistFullName = computed(() => {
  if (coaching.value?.specialist) {
    return coaching.value?.specialist?.firstName + ' ' + coaching.value?.specialist?.lastName;
  } else {
    return 'Keine Daten';
  }
});

const supervisorFullName = computed(() => {
  if (coaching.value?.supervisor) {
    return coaching.value?.supervisor?.firstName + ' ' + coaching.value?.supervisor?.lastName;
  } else {
    return 'Keine Daten';
  }
});

const unitsDoneBySpecialist = computed(() =>
    (props.coaching?.unitsDoneBySpecialist || 0) +
    (props.coaching?.unitsDoneByEmergencySupervisor || 0),
);

const unitsDoneBySupervisor = computed(() =>
    props.coaching?.unitsDoneBySupervisor || 0,
);

const unitsLeftToBeDone = computed(() =>
    2.33 * unitsDoneBySupervisor.value - unitsDoneBySpecialist.value,
);

const formatNumber = (value) =>
    new Intl.NumberFormat('de-DE',
        { minimumFractionDigits: 2, maximumFractionDigits: 2 },
    ).format(value);

const fontColor = computed(() =>
    props.progressBarColor === '#FFAC1C!important' ? 'black' : 'white',
);

const progressBarStyle = (width) => ({
  width: `${width}%`,
  backgroundColor: props.progressBarColor,
  color: fontColor.value,
  fontSize: '12px',
});

</script>

<style scoped>

</style>